import React from 'react';
import PropTypes from 'prop-types';

import AsyncSelect from 'react-select/async';

import Menu from './menu';
import ValueContainer from 'helpers/react_select/components/search_value_container';
import { getInlineStyles, mapId } from 'helpers/react_select_helpers';
import { searchProjects } from 'bundles/apex/deals/connect_to_listing/api';

const styles = getInlineStyles(ValueContainer.styleOverrides);

export default function ProjectSelector({ deal, project, onChange }) {
  return (
    <div className="form">
      <div className="form-group">
        <label>Search Marketing Properties</label>
        <AsyncSelect
          classNamePrefix=""
          components={{ DropdownIndicator: null, Menu, ValueContainer }}
          getOptionValue={mapId}
          isClearable
          loadOptions={(query, callback) => searchProjects(deal, query, callback)}
          placeholder="Search name or address"
          styles={styles}
          value={project}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

ProjectSelector.propTypes = {
  deal: PropTypes.object,
  project: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
